import {

  createBankAccountApi,

  createCashAccountApi,

  createOtherAccountApi,

  getAllVehicleNumber,
  getFastagMaster,
  getFuelCardMaster,
  handleKeyDown,
} from "_services";
import { getUserFirm } from "_services/accountsServices/firmServices";

import {
  CommonInput,
  CommonModal,
  CustomSelect,
} from "components";
import images from "constants/images";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices";
// import {addTransactionsTabs} from 'constants/constant'

const AddAccountingAccount = (props) => {
  let { callBackAddAccount = () => { }, branchFirmId, isOpen } = props;

  const addTransactionsTabs = [
    { id: 1, title: "Cash", value: "cash", img: images.RP_WALLET.default },
    { id: 2, title: "Bank", value: "bank", img: images.BANK_ICON.default },
    {
      id: 3,
      title: "Fuel Card",
      value: "fuel_card",
      img: images.FUELCARD_ICON.default,
    },
    {
      id: 4,
      title: "Other",
      value: "other",
      img: images.OTHER_TRANS_ICON.default,
    },
    {
      id: 5,
      title: "Fastag",
      value: "fastag",
      img: images.FASTAG_ICON.default,
    },
  ];

  const initialFrom = {
    company_id: StorageServices.getCompanyId(),
    holder_name: "",
    number: "",
    ifsc: "",
    bank: "",
    bank_opening_balance: "",
    bank_credit_or_debit: 1,
    bank_prefix: "",
    show_bank_prefix: false,
    vendor_account: false,
    firm_id: {},

    cash_name: "",
    cash_opting_bal: "",
    cash_credit_or_debit: 1,
    cash_prefix: "",
    show_cash_prefix: false,

    other_name: "",
    other_opening_balance: "",
    other_credit_or_debit: 1,
    other_prefix: "",
    show_other_prefix: false,
  };

  const { masterData } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState(Number(isOpen));
  const [form, setForm] = useState(initialFrom);
  const [formError, setFormError] = useState("");
  const [bankList, setBankList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [firmDataList, setFirmDataList] = useState([]);

  // Pass closeModal as a prop to CommonModal

  const changeActiveTab = async (event, value) => {
    event.preventDefault();
    setActiveTab(value);
  };

  const arryOptions = [
    { label: "Arjun", value: "01" },
    { label: "Anvit", value: "02" },
  ];

  useEffect(() => {
    const list = masterData?.bank_list?.map((i) => {
      return {
        label: i?.name,
        value: i?.code,
      };
    });
    setForm({ ...form, bank: list[0].value });
    setBankList(list);

  }, [masterData]);

  const handleSearch = async (ifscCode) => {
    // Fetch bank details from Razorpay IFSC API

    const validateIFSC = (code) => {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      return ifscRegex.test(code.toUpperCase());
    };
    const valid = validateIFSC(ifscCode);


    if (valid) {
      console.log("Valid IFSC code. Proceeding to fetch details...");
      try {
        const res = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
        if (!res.ok) {
          return res
        }
        const data = await res.json();
        return data
      } catch (err) {
        toast.error(err.message);
      }
    }
  }


  const handleOnChange = async (name, value) => {
    const stateObj = { ...form, [name]: value };

    if (name === "show_bank_prefix" && value == false) {
      stateObj.bank_prefix = '';
    }

    if (name === "ifsc" && value.length === 11) {
      console.log("IFSC code entered, fetching bank details...");
      try {
        const bankDetails = await handleSearch(value);

        if (bankDetails && bankDetails.BRANCH) {
          stateObj.branch_name = bankDetails.BRANCH;
          stateObj.branch_code = bankDetails.BANKCODE;
          stateObj.city_name = bankDetails.CITY;
          stateObj.state_name = bankDetails.STATE;
          stateObj.bank = bankDetails.BANK;
          // stateObj.holder_name = bankDetails.BANK;

        } else {

          stateObj.branch_name = "";
          setFormError(prev => ({
            ...prev,
            ifsc: "invalid IFSC code",
          }));
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        stateObj.branch_name = "";
      }
    }
    setForm(stateObj);

    if (!!formError) {
      const validationSchemas = {

        1: errorSchema.cashSchema,
        2: errorSchema.bankSchema,
        4: errorSchema.otherSchema,

      };
      const validationResult = await utils.checkFormError(
        stateObj,
        validationSchemas[activeTab]
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleOnSubmit = async () => {
    const validationSchemas = {
      1: errorSchema.cashSchema,
      2: errorSchema.bankSchema,
      4: errorSchema.otherSchema,
    };



    const validationResult = await utils.checkFormError(
      { ...form },
      validationSchemas[activeTab]
    );

    console.log("validationResult", validationResult)
    const payloads = {
      1: {
        company_id: form?.company_id,
        name: form?.cash_name,
        opening_balance: form?.cash_opting_bal,
        credit_or_debit: form?.cash_credit_or_debit,
        prefix: form?.cash_prefix,
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
      },
      2: {
        company_id: form?.company_id,
        name: form?.holder_name,
        number: form?.number,
        ifsc: form?.ifsc,
        bank: form?.bank,
        opening_balance: form?.bank_opening_balance,
        credit_or_debit: form?.bank_credit_or_debit,
        prefix: form?.bank_prefix,
        vendor_account: form?.vendor_account,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',
      },
      4: {
        company_id: form?.company_id,
        name: form?.other_name,
        opening_balance: form?.other_opening_balance,
        credit_or_debit: form?.other_credit_or_debit,
        prefix: form?.other_prefix,
        firm_id: form?.firm_id?.value ? form?.firm_id?.value : '',
        firm_name: form?.firm_id?.label ? form?.firm_id?.label : '',
      },

    };

    const apiCalls = {
      1: createCashAccountApi,
      2: createBankAccountApi,
      4: createOtherAccountApi,
    };

    if (validationResult == true) {
      setLoading(true);
      try {
        const payload = payloads[activeTab];
        const apiCall = apiCalls[activeTab];

        if (!payload || !apiCall) {
          toast?.error("Invalid tab or missing payload");
          return;
        }

        const res = await apiCall(payload);
        if (res?.responseCode === 200) {
          callBackAddAccount()
          props?.closeModal()
          toast?.success(res?.responseMessage ? res?.responseMessage : "Account add successfully");
        } else {
          setLoading(false);
          toast?.error(res?.responseMessage);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
        toast?.error(error?.message || "An unexpected error occurred");
      }
    } else {
      setLoading(false);
      setFormError(validationResult);
    }
  };


  const getDataFirmList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
      }
      const res = await getUserFirm(object);
      if (res?.responseCode == 200) {
        let apiData = res?.data?.firm_list?.map((el) => {

          return {
            ...el,
            label: el?.firm_id?.firm,
            value: el?.firm_id?._id,
          }
        })
        setFirmDataList(apiData);
        // if (!isOpen?._id) {
        if (apiData?.length === 1) {
          setForm((s) => ({
            ...s,
            firm_id: apiData[0]
          }))
        } else {
          setForm((s) => ({
            ...s,
            firm_id: {}
          }))
        }
        // }
      }
    } catch (error) {
    }
  }

  useEffect(() => {
    getDataFirmList();
  }, [])

  useEffect(() => {

    if (firmDataList?.length > 0 && !isOpen?._id) {
      const storageFirmId = StorageService.getFirmId();

      let findObject = firmDataList.find((el) => el?.value === storageFirmId);

      const branchFirm = branchFirmId?._id;
      let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

      setForm((s) => ({
        ...s,
        ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
      }));
    }
  }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);


  const propsTransAccount = {
    ...props,
    onSubmit: handleOnSubmit,
    isLoadding: loading,
    disabled: loading,
    show: "show",
    firm: form?.firm_id
  };


  return (
    <>
      <CommonModal {...propsTransAccount}>
        <div className="addLr_body">

          <div className="addPr_flBx _addTrns_flx">
            <ul
              className="nav nav-tabs cstNew_tabs _truckSelection"
              id="addParty"
              role="tablist"
            >
              {addTransactionsTabs?.length > 0 ? (
                addTransactionsTabs?.map((item, indx) => (
                  <li className="nav-item" role="presentation" key={indx}>
                    <button
                      id={item?.id}
                      className={
                        "nav-link " + (item?.id === activeTab ? "active" : "")
                      }
                      type="button"
                      aria-selected={item?.id === activeTab}
                      disabled={item?.id !== activeTab}
                    // onClick={(e, val) => changeActiveTab(e, item?.id)}
                    >
                      <img
                        src={item.img}
                        className=""
                      //   onClick={(e) => {
                      //     e.stopPropagation();
                      //     setActiveTab({});
                      //     setFilters((s) => ({ ...s, lorry_type_id: '' }))
                      //   }}
                      />

                      {item?.title}
                    </button>
                  </li>
                ))
              ) : (
                <p className="p-2 mt-3"> Loading... </p>
              )}
            </ul>
          </div>


          {activeTab === 1 && (
            <>
              <div className="_allDflx mt-4">

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Cash Account Name"
                    label="Cash Account Name"
                    name="cash_name"
                    focus={!!formError?.cash_name}
                    error={formError.cash_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.cash_name}
                    maxLength={30}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="cash_opting_bal"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.cash_opting_bal}
                    error={formError.cash_opting_bal}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.cash_opting_bal}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="cash_credit_or_debit"
                        checked={i.value == form.cash_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                {!form?.show_cash_prefix && (
                  <div className="d-flex justify-content-end">
                    <button
                      className="_addMo_deBtn"
                      onClick={() => handleOnChange("show_cash_prefix", true)}
                    >
                      Add More Detail
                    </button>
                  </div>
                )}

                {form?.show_cash_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="cash_prefix"
                      focus={!!formError?.cash_prefix}
                      error={formError.cash_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.cash_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}
          {activeTab === 2 && (
            <>
              <div className="_allDflx mt-4">

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Bank Account Name"
                    label="Bank Account Name"
                    name="holder_name"
                    focus={!!formError?.holder_name}
                    error={formError.holder_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.holder_name}
                    maxLength={50}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.123456789012345"
                    label="Account Number"
                    name="number"
                    focus={!!formError?.number}
                    error={formError.number}
                    onChange={({ target: { name, value } }) => {
                      if (/^\d*$/.test(value)) {
                        handleOnChange(name, value);
                        // setPhoneError("");
                      }
                    }}
                    maxLength={20}
                    value={form?.number}

                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Ex.SBIN0000000"
                    label="IFSC Code"
                    name="ifsc"
                    focus={!!formError?.ifsc}
                    error={formError.ifsc}
                    onChange={({ target: { name, value } }) => {
                      const upperLatter = value.toUpperCase();

                      handleOnChange(name, upperLatter)
                    }
                    }
                    value={form?.ifsc}
                    maxLength={11}
                  />
                </div>

                {/* <div>
                  <CustomSelect
                    options={bankList}
                    label="Bank Name"
                    placeholder="Bank Name"
                    name="bank"
                    focus={!!formError?.bank}
                    error={formError.bank}
                    onSelect={(data) => handleOnChange("bank", data?.value)}
                    value={bankList?.find((i) => i?.value == form?.bank)}
                  />
                </div> */}

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="bank_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.bank_opening_balance}
                    error={formError.bank_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.bank_opening_balance}
                    // onKeyDown={handleKeyDown}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="bank_credit_or_debit"
                        checked={i.value == form.bank_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>





                <div className="d-flex gap-4" style={{ fontWeight: 500 }}>
                  Supplier / Vendor Account
                </div>
                <div className="d-flex gap-5">
                  {[
                    { label: "Required", value: true },
                    { label: "Not Required", value: false },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i.label}>
                      <input
                        className="form-check-input"
                        id={i.label}
                        type="radio"
                        name="vendor_account"
                        checked={form.vendor_account === i.value}
                        value={i.value}
                        onChange={({ target }) =>
                          handleOnChange(target.name, target.value === "true")
                        }
                      />
                      <label htmlFor={i.label} className="form-check-label">
                        {i.label}
                      </label>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    className="_addMo_deBtn"
                    onClick={() => handleOnChange("show_bank_prefix", !form?.show_bank_prefix)}
                  >
                    {form?.show_bank_prefix ? "Remove More Details" : "Add More Detail"}
                  </button>
                </div>
                {form?.show_bank_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="bank_prefix"
                      focus={!!formError?.bank_prefix}
                      error={formError.bank_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.bank_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}
          {activeTab === 4 && (
            <>
              <div className="_allDflx mt-4">

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Account Name"
                    label="Account Name"
                    name="other_name"
                    focus={!!formError?.other_name}
                    error={formError.other_name}
                    onChange={({ target: { name, value } }) =>
                      handleOnChange(name, value)
                    }
                    value={form?.other_name}
                    maxLength={30}
                  />
                </div>

                <div>
                  <CommonInput
                    type="text"
                    placeholder="Opening Balance "
                    label="Opening Balance (₹)"
                    name="other_opening_balance"
                    className="__rupeeSymbol"
                    rupeeSymbol={true}
                    focus={!!formError?.other_opening_balance}
                    error={formError.other_opening_balance}
                    onChange={({ target: { name, value } }) => {
                      const validValue = value.replace(/[^0-9.]/g, "");
                      const formattedValue = validValue.includes(".")
                        ? validValue.split(".")[0] +
                        "." +
                        validValue.split(".")[1].slice(0, 2)
                        : validValue;

                      handleOnChange(name, formattedValue);
                    }}
                    value={form?.other_opening_balance}
                    maxLength={10}
                  />
                </div>

                <div className="d-flex gap-4">
                  {[
                    { label: "(+) Balance", value: 1 },
                    { label: "(-) Balance", value: 2 },
                  ].map((i) => (
                    <div className="_dualCheckr_bx" key={i?.value}>
                      <input
                        className="form-check-input"
                        id={i?.label}
                        type="radio"
                        name="other_credit_or_debit"
                        checked={i.value == form.other_credit_or_debit}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, Number(value))
                        }
                      />
                      <label htmlFor={i?.label} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  ))}
                </div>

                {!form?.show_other_prefix && (
                  <div className="d-flex justify-content-end">
                    <button
                      className="_addMo_deBtn"
                      onClick={() => handleOnChange("show_other_prefix", true)}
                    >
                      Add More Detail
                    </button>
                  </div>
                )}

                {form?.show_other_prefix && (
                  <div>
                    <CommonInput
                      type="text"
                      placeholder="Prefix"
                      label="Prefix"
                      name="other_prefix"
                      focus={!!formError?.other_prefix}
                      error={formError.other_prefix}
                      onChange={({ target: { name, value } }) =>
                        handleOnChange(name, value)
                      }
                      value={form?.other_prefix}
                    />
                    <p class="_bottomPLine">Leave Blank to Auto Generate</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

      </CommonModal>




    </>
  );
};

export default AddAccountingAccount
